var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowCloseButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9525",
    "data-name": "\\u9577\\u65B9\\u5F62 9525",
    width: 17,
    height: 17,
    transform: "translate(0 -0.214)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17186",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17186",
    transform: "translate(0.076 -1.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15522",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15522",
    transform: "translate(-0.076 1.523)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21234",
    "data-name": "\\u30D1\\u30B9 21234",
    d: "M31.944,33.843a1.9,1.9,0,0,1-1.343-.555l-5.179-5.179-5.179,5.179A1.9,1.9,0,0,1,17.555,30.6l5.179-5.179-5.179-5.179a1.9,1.9,0,0,1,2.687-2.687l5.179,5.179L30.6,17.555a1.9,1.9,0,0,1,2.687,2.682l-5.179,5.179L33.288,30.6a1.9,1.9,0,0,1-1.343,3.242",
    transform: "translate(-17.029 -17)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowCloseButton);
export default __webpack_public_path__ + "static/media/windowCloseButton.ea1b3a61aba03b1b8dc2b0baa0d44529.svg";
export { ForwardRef as ReactComponent };